var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgModel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 9.01L10.01 8.999M14 9.01L14.01 8.999M10 13.01L10.01 12.999M14 13.01L14.01 12.999M10 17.01L10.01 16.999M14 17.01L14.01 16.999M6 20.4V5.6C6 5.44087 6.06321 5.28826 6.17574 5.17574C6.28826 5.06321 6.44087 5 6.6 5H12V3.6C12 3.44087 12.0632 3.28826 12.1757 3.17574C12.2883 3.06321 12.4409 3 12.6 3H17.4C17.5591 3 17.7117 3.06321 17.8243 3.17574C17.9368 3.28826 18 3.44087 18 3.6V20.4C18 20.5591 17.9368 20.7117 17.8243 20.8243C17.7117 20.9368 17.5591 21 17.4 21H6.6C6.44087 21 6.28826 20.9368 6.17574 20.8243C6.06321 20.7117 6 20.5591 6 20.4Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgModel);
export default __webpack_public_path__ + "static/media/model.114a89240c0e54ef2dafc4ceaf0948af.svg";
export { ForwardRef as ReactComponent };